module.exports = __webpack_public_path__ + "img/balao_balao_4.fb92e85c.svg";